exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.dataContainer[data-v-2a212627]{\n     width:1100px;\n     margin-left: 0px;\n     font-family: 'Oswald', sans-serif;       \n     font-weight: 200;\n}\n@media screen and (max-width: 981px) {\n.dataContainer[data-v-2a212627]{\n      width:99%;\n}\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-2a212627","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 76
// module chunks = 0